import React from "react"
import { unCollapseSideBar } from "context/applicationContext"

function NotFound() {
	unCollapseSideBar()
	return <h1 className="not-found">NOT FOUND</h1>
}

export default NotFound
